import 'components/Pagelayout/global.scss';
import { PageLayout } from './PageLayout';
export default PageLayout;
